<template>
    <div>
        <nav
            class="navbar navbar-expand-xl navbar-dark flex-nowrap"
            :class="[navbarFixed, navbarDirection]"
            style="min-height: 95px;"
            :style="$bgColor(color.primary)">
            <button @click="toggleDrawer" class="navbar-toggler" type="button">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div v-if="logo.type" class="mx-auto" style="height:60px;">
                <img class="nch--nav-brand" :src="image(logo.src)" alt="logo" />
            </div>
                <span :style="{ color: color.secondary }" class="textLogo" v-else>{{ logo.text }}</span>
            <Profile
                v-if="user && !$store.getters.USER.public"
                :user="user"
                :cart="cart"
                :color="color" />
            <Login v-else :color="color" />
        </nav>
        <fade-transition :duration="500" :delay="50">
            <div v-show="open" class="nch--drawer-overlay">
                <slide-x-left-transition :duration="1000" :delay="2000">
                    <div v-show="open" class="nch--drawer">
                        <div class="list-group">
                            <Language mobile :languages="languages" />
                            <a
                                v-for="item in items"
                                :key="item.name"
                                :href="item.href"
                                class="list-group-item list-group-item-action"
                                :class="item.dev ? 'disabled' : ''"
                            > {{ $t(item.name) }} </a>
                            <a v-if="user" href="#" @click.stop="logoutUser" class="list-group-item list-group-item-action">{{$t('header.profile.logout')}}</a>
                        </div>
                    </div>
                </slide-x-left-transition>
            </div>
        </fade-transition>
    </div>

</template>

<script>
import Login from './NavbarLogin'
import Profile from './NavbarProfile'
import Language from './NavbarLanguage'
import {
    FadeTransition,
    SlideXLeftTransition
} from 'vue2-transitions'

export default {
    name: 'NavbarMobile',
    components: {
        Login,
        Profile,
        Language,
        FadeTransition,
        SlideXLeftTransition,
    },
    data() {
        return {
            open: false
        }
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
        logo: {
            type: Object,
            required: true
        },
        user: {
            type: Object | undefined,
            required: true
        },
        cart: {
            type: Number,
            required: true
        },
        languages: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true,
        }
    },
    computed: {
        navbarFixed() {
            if (this.$store.getters.NAVBAR_FIXED) return 'fixed-top'
        },
        navbarDirection() {
            if (this.$store.getters.NAVBAR_POSITION) return 'revert'
        }
    },
    methods: {
        toggleDrawer() {
            return this.open = !this.open
        },
        image({
            host,
            original_file,
            urls
        }, size = 'original') {
            if (urls && urls[size]) {
                return urls[size]
            }
            return `/storage/${host}/${size}/${original_file}`
        },
        logoutUser() {
            this.$loading.show()

            window.axios.post('/logout')
                .then(response => {
                    setTimeout(() => {
                        localStorage.removeItem('nochalks_token');
                        location.href = '/login';
                    }, 150);
                })
                .catch(error => {
                    setTimeout(() => {
                        this.$notify({
                            type: 'danger',
                            message: this.$t('login.messages.error')
                        })
                    }, 150);
                })
        },
    }
}
</script>

<style scoped>
.nch--drawer {
    position: fixed;
    height: 100vh;
    width: 80%;
    background-color: white;
    z-index: 1201;
    opacity: 1;
}
.nch--drawer-overlay {
    top: 95px;
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgba(41, 48, 59, .55);
    z-index: 1200;
}
.textLogo {
    text-transform: capitalize;
    font-size: 1.3rem
}
.profile-mobile {
    background-color: #cccccc;
    height: 100px;
}

.list-group-item {
    padding: 0.5rem 1rem;
}
</style>
